import {
  createSlice,
  createAsyncThunk,
  createSelector,
} from "@reduxjs/toolkit";
import axios from "@/features/axiosHelper";

const initialState = {
  artifacts: [],
  workflows: [],
  selectedArtifacts: [],
  date: "2024/09/26",
  lifecycle: "Order",
  status: "idle",
  error: null,
  isShrunk: false,
};

const artifactsMapSlice = createSlice({
  name: "artifactsMap",
  initialState,
  reducers: {
    addSelectedArtifact: (state, action) => {
      const { selectedArtifact } = action.payload;
      if (!state.selectedArtifacts.includes(selectedArtifact)) {
        state.selectedArtifacts.push(selectedArtifact);
      }
    },
    removeSelectedArtifact: (state, action) => {
      const { selectedArtifact } = action.payload;
      state.selectedArtifacts = state.selectedArtifacts.filter(
        (artifact) => artifact !== selectedArtifact
      );
    },
    setArtifactLifecycle: (state, action) => {
      const { lifecycle } = action.payload;
      state.lifecycle = lifecycle;
    },
    setArtifactMapDate: (state, action) => {
      const { date } = action.payload;
      state.date = date;
    },
    toggleSelectedArtifact: (state, action) => {
      const { selectedArtifact } = action.payload;
      if (state.selectedArtifacts.includes(selectedArtifact)) {
        state.selectedArtifacts = state.selectedArtifacts.filter(
          (artifact) => artifact !== selectedArtifact
        );
      } else {
        state.selectedArtifacts.push(selectedArtifact);
      }
    },
    toggleShrink: (state) => {
      state.isShrunk = !state.isShrunk;
    },
  },
  extraReducers: (builder) => {
  },
});

// Selectors
export const selectArtifacts = (state) =>
  state.tempInfo.artifactsMap?.artifacts;
export const selectSelectedConnection = (state) =>
  state.tempInfo.connectionsBar?.selectedConnection;
export const selectSelectedArtifacts = (state) =>
  state.tempInfo.artifactsMap.selectedArtifacts;
export const selectLifecycle = (state) => state.tempInfo.artifactsMap.lifecycle;
export const selectDate = (state) => state.tempInfo.artifactsMap.date;
export const selectWorkflows = (state) => state.tempInfo.artifactsMap.workflows;
export const selectIsShrunk = (state) => state.tempInfo.artifactsMap.isShrunk;
const selectAllWorkflows = (state) => state.tempInfo.artifactsMap.workflows;

export const selectFilteredWorkflows = (code) =>
  createSelector(
    [selectAllWorkflows, selectSelectedConnection],
    (workflows, selectedConnection) => {
      console.log(
        "selectFilteredWorkflows - selectedConnection:",
        selectedConnection
      );
      console.log("selectFilteredWorkflows - code:", code);
      let filteredWorkflows;
      if (selectedConnection === "All") {
        filteredWorkflows = code
          ? workflows.filter((workflow) => workflow.code === code)
          : workflows;
      } else {
        filteredWorkflows = workflows.filter(
          (workflow) =>
            workflow.name === selectedConnection &&
            (!code || workflow.code === code)
        );
      }
      console.log(
        "selectFilteredWorkflows - filteredWorkflows:",
        filteredWorkflows
      );
      return filteredWorkflows;
    }
  );

export const selectRelevantWorkflowDisplay = (code) =>
  createSelector([selectFilteredWorkflows(code)], (filteredWorkflows) => {
    console.log(
      "selectRelevantWorkflowDisplay - filteredWorkflows:",
      filteredWorkflows
    );
    if (filteredWorkflows.length > 1) {
      return `${filteredWorkflows.length}`;
    }
    return filteredWorkflows.length === 1
      ? filteredWorkflows[0].connectionDisplay
      : 0; // MUI Badges automatically don't display 0
  });

export const selectRelevantWorkflowName = (code) =>
  createSelector([selectFilteredWorkflows(code)], (filteredWorkflows) => {
    console.log(
      "selectRelevantWorkflowName - filteredWorkflows:",
      filteredWorkflows
    );
    if (filteredWorkflows.length > 1) {
      return `${filteredWorkflows.length}`;
    }
    return filteredWorkflows.length === 1
      ? filteredWorkflows[0].connectionName
      : null;
  });

// Actions
export const {
  addSelectedArtifact,
  removeSelectedArtifact,
  setArtifactLifecycle,
  setArtifactMapDate,
  toggleSelectedArtifact,
  toggleShrink,
} = artifactsMapSlice.actions;

export default artifactsMapSlice.reducer;
